<template>
<div class="login">
    <div class="login_form">
        <div class="item_form">
            <div class="form_title">手机号</div>
            <div class="form_filed">
                <van-field v-model="phone" placeholder="请输入您的手机号" :border="false" type="tel" />
                <!-- <div class="find_code" @click="getCode">获取</div> -->
                <van-button :loading="codeLoading" :disabled="codeBtnDisabled" class="find_code" @click="getCode">获取</van-button>
            </div>
        </div>
        <div class="item_form">
            <div class="form_title">短信验证码</div>
            <div class="form_filed">
                <van-field v-model="password" placeholder="请输入您收到的验证码" type="digit" :border="false" />
            </div>
        </div>
        <van-button block :loading="submitLoading" class="login_action" @click="login">立即登录</van-button>
        <!-- <van-button block :loading="btnLoading" :disabled="submitLoading" class="login_action" @click="login">立即登录</van-button> -->
    </div>
    <!-- 微信登录 -->
    <div class="login_wechat" v-if="is_weixin" @click="loginWechat">
        <img :src="publicPath+'statics/images/login_wechat.png'" alt="" class="icon_wechat">
    </div>
</div>
</template>

<script>
import router from "../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../.././vuex/mutation_types";
export default {
    name: 'login',
    data() {
        return {
            phone: '',
            password: '',
            submitLoading: false, // 登录加载状态
            btnLoading: false, // 加载loading
            publicPath: process.env.BASE_URL,
            delyTime: 5, // 获取验证间隔时间 s
            codeBtnDisabled: false, // 验证码可用状态
            codeLoading: false, // 验证码加载状态
            is_weixin: false, // 是否微信环境
            wxCode: null, //微信code
            getCodeUrl: this.$publicData.domain+'/home/wx-code?url=/login', // 测试
            redirect: localStorage.getItem('redirect')
        };
    },
    created: function () {
        // console.log()
        // console.log(this.$route.query.redirect)
        if(this.redirect && (this.redirect.split('?')[0] == '/set/bindPhone')){
            this.redirect = "";
            localStorage.removeItem('redirect')
        }
        this.checkWeiXin()
    },
    methods: {
        // 登录
        login() {
            var that = this;
            that.submitLoading = true;
            if (!that.phone) {
                that.$toast('请输入手机号');
                that.submitLoading = false;
                return
            } else if (!(/^1[23456789]\d{9}$/.test(that.phone))) {
                that.$toast('请输入合法的手机号');
                that.submitLoading = false;
                return
            }
            if (!that.password) {
                that.$toast('请输入验证码');
                that.submitLoading = false;
                return
            }
            var param = {
                'phone': that.phone,
                'code': that.password
            }
            that.$api.user.login(param).then(res => {
                that.submitLoading = false;
                if (res.code === 200) {
                    console.log(res)
                    let phone = res.result.user.username.substr(0, 3) + '****' + res.result.user.username.substr(-4);
                    let name = '';

                    console.log('login,', res)
                    if (res.result.user && res.result.user.userdata && res.result.user.userdata.thumb) {
                        localStorage.setItem('thumb', res.result.user.userdata.thumb);
                    }
                    if (res.result.user.userdata) {
                        name = res.result.user.userdata.nickname == null ? phone : res.result.user.userdata.nickname
                    } else {
                        name = res.result.user.username
                    }
                    console.log('########name:', name);
                    that.$store.commit(LOGIN, {
                        name: name,
                        token: res.result.user.token,
                        uuid: res.result.user.uuid,
                    });
                    that.$toast('登录成功');
                    // if (this.$route.query.redirect) {
                    //     that.$router.push({
                    //         path: this.$route.query.redirect
                    //     });
                    // } else {
                    //     that.$router.push('/');
                    // }
                    if (this.redirect) {
                        that.$router.push({
                            path: this.redirect
                        });
                        localStorage.removeItem('redirect')
                    } else {
                        that.$router.push('/');
                    }
                }
            })
        },
        // 获取验证码
        getCode() {
            var that = this;
            if (!that.phone) {
                that.$toast('请输入手机号');
                return
            } else if (!(/^1[3456789]\d{9}$/.test(that.phone))) {
                that.$toast('请输入合法的手机号');
                return
            }
            var param = {
                phone: that.phone,
                type: 0 // type: 1 // 0普通 1修改手机号 2小程序绑定手机号
            }

            that.codeBtnDisabled = true
            that.codeLoading = true
            that.$api.user.code(param).then(res => {
                if (res.code === 200) {
                    that.$toast('已发送');
                    var s = setInterval(function () {
                        var dely1 = parseInt(that.delyTime) - 1;
                        that.delyTime = dely1
                        console.log(dely1);
                        if (dely1 == 0) {
                            clearInterval(s);
                            that.codeBtnDisabled = false
                            that.codeLoading = false
							that.delyTime = 5;
                        }
                    }, 1000);
                }
                // that.btnLoading = false
                // if (res.result.role == 1) {
                //     // 管理员登录
                //     that.$router.push('/m/manage/index');
                // } else if (res.result.role == 2) {
                //     // 代销
                //     that.$router.push('/m/index');
                // }
            })
        },
        // 微信登录
        loginWechat() {
            var that = this
            console.log('loginWechat:' + this.wxCode)
            if (this.wxCode === null || this.wxCode === undefined || this.wxCode === "") {
                window.location.href = this.getCodeUrl;
                return;
            }
            var param = {
                'code': this.wxCode
            }
            this.$api.user.wxlogin(param).then(res => {
                if (res.code === 200) {
                    console.log(res)
                    let phone = res.result.user.username.substr(0, 3) + '****' + res.result.user.username.substr(-4);
                    let name = '';

                    console.log('login,', res)
                    localStorage.setItem('thumb', res.result.user.userdata.thumb);
                    if (res.result.user.userdata) {
                        name = res.result.user.userdata.nickname == null ? phone : res.result.user.userdata.nickname
                    } else {
                        name = res.result.user.username
                    }
                    console.log('########name:', name);
                    this.$store.commit(LOGIN, {
                        name: name,
                        token: res.result.user.token,
                        uuid: res.result.user.uuid,
                    });
                    this.$toast('登录成功');
                    // if (this.$route.query.redirect) {
                    //     that.$router.push({
                    //         path: this.$route.query.redirect
                    //     });
                    // } else {
                    //     this.$router.push('/');
                    // }
                    if (this.redirect) {
                        that.$router.push({
                            path: this.redirect
                        });
                        localStorage.removeItem('redirect')
                    } else {
                        this.$router.push('/');
                    }
                } else {
                    console.log(201201)
                    console.log(res.result.token)
                    if (res.code === 201) {
                        this.$store.commit(LOGIN, {
                            token: res.result.token,
                        });
                        this.$router.push({
                            path: '/set/bindPhone',
                            query: {
                                token: res.result.token,
                                redirect: that.redirect
                            }
                        })
                        localStorage.removeItem('redirect')
                    }
                    this.$toast(res.message)
                }
            })
        },
        // 判断 是否在微信环境
        checkWeiXin() {
            var ua = window.navigator.userAgent.toLowerCase()
            if (ua.indexOf('micromessenger') == -1) {
                console.log("不在微信或者小程序中")
                this.is_weixin = false
            } else {
                console.log('在微信环境')
                this.is_weixin = true
                var code = this.getUrlCode()['code'];
                console.log(code)
                if (code != null && code != undefined && code != "") {
                    this.wxCode = code;
                    this.loginWechat()
                    // this.wxLogin()
                }
            }
        },
        // 截取url中的code方法
        getUrlCode() {
            var allUrl = location.href;
            var url = allUrl.substring(allUrl.indexOf("?"), allUrl.length);
            this.winUrl = url;
            var theRequest = new Object();
            if (url.indexOf("?") != -1) {
                var str = url.substr(1);
                var strs = str.split("&");
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
                }
            }
            return theRequest;
        },

    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/deep/.van-loading__spinner--circular {
    width: .37rem !important;
    height: .37rem !important;
}
</style>
